// Footer.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faInstagram,
	faFacebookF,
	faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./Footer.css";

function Footer() {
	return (
		<footer className="footer">
			<div className="footer-content">
				<div className="footer-left">
					<h2>
						Sibling
						<br /> Kinect
					</h2>
					<div className="social-icons">
						<a
							href="https://www.instagram.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FontAwesomeIcon icon={faInstagram} />
						</a>
						<a
							href="https://www.facebook.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FontAwesomeIcon icon={faFacebookF} />
						</a>
						<a
							href="https://www.youtube.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FontAwesomeIcon icon={faYoutube} />
						</a>
						<a href="mailto:siblingkinect@gmail.com">
							<FontAwesomeIcon icon={faEnvelope} />
						</a>
					</div>
					<p>
						Sibling Kinect provides a structured and supportive environment that
						aims to empower siblings, foster understanding, and promote healing
						within the family unit.
					</p>
				</div>
				<div className="footer-right">
					<img src="/images/footerImage.png" alt="Nature" />
					<ul>
						<li>
							<a href="/">Home</a>
						</li>
						<li>
							<a href="/services">Services</a>
						</li>
						<li>
							<a href="/about">About</a>
						</li>
						<li>
							<a href="/resources">Resources</a>
						</li>
						<li>
							<a href="/contact">Contact Us</a>
						</li>
					</ul>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
